<template>
	<div class="calculator__slider">
		<div class="_mdc-slider-wrapper">
			<label :for="name" class="ln-u-visuallyhidden">{{ label }}</label>

			<div class="_mdc-slider-inner">
				<input
					:id="name"
					:value="value"
					:readonly="disabled"
					:name="name"
					type="range"
					min="0"
					max="100"
					step="0.25"
					@input="onChange"
				/>

				<div
					class="mdc-slider"
					aria-valuemin="0"
					aria-valuemax="100"
					:aria-valuenow="value"
					data-step="0.25"
				>
					<div class="mdc-slider__track-container">
						<div class="mdc-slider__track"></div>
					</div>
					<div class="mdc-slider__thumb-container">
						<div class="mdc-slider__pin">
							<span class="mdc-slider__pin-value-marker"></span>
						</div>
						<svg class="mdc-slider__thumb" width="21" height="21">
							<circle cx="10.5" cy="10.5" r="7.875"></circle>
						</svg>
						<div class="mdc-slider__focus-ring"></div>
					</div>
				</div>

				<div class="_mdc-slider__indicators">
					<span
						v-for="(indicator, i) in indicators"
						:key="i"
						class="_mdc-slider__indicator"
						:style="{ '--position': `${indicator.value}%` }"
					>
						<span class="_mdc-slider__indicator-text">
							{{ indicator.label }}
						</span>
					</span>
				</div>
			</div>
		</div>

		<InputHint
			v-if="showCalculatorError"
			class="calculator__slider-error"
			name="calculator"
			role="alert"
		/>
	</div>
</template>

<script>
import InputHint from './InputHint.vue';

export default {
	name: 'Slider',
	components: { InputHint },
	props: {
		value: Number,
		disabled: Boolean,
		name: String,
		label: String,
		onChange: Function,
		indicators: Array,
		showCalculatorError: Boolean
	},
	watch: {
		value() {
			setTimeout(() => {
				this.input.dispatchEvent(new Event('input'));
			});
		}
	},
	mounted() {
		this.initCustomFormFields(this.$el);

		this.input = this.$el.querySelector('input');
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__slider-error.calculator__slider-error {
	padding-left: 0;
	padding-right: 0;
	margin-right: -3.75rem;
}

.calculator__slider .mdc-slider .mdc-slider__track-container {
	background-color: rgba(0, 0, 0, 0.1);
}
.calculator__slider .mdc-slider .mdc-slider__track {
	background-color: var(--color);
}
.calculator__slider .mdc-slider .mdc-slider__pin {
	border: 2px solid var(--color);
	background: #fff;
	box-sizing: border-box;
}
.calculator__slider .mdc-slider .mdc-slider__pin-value-marker {
	font-size: 75%;
	background: #fff;
	border-radius: 100%;
}
.calculator__slider .mdc-slider .mdc-slider__thumb {
	fill: var(--color);
	stroke: var(--color);
}
.calculator__slider .mdc-slider ._mdc-slider-inner::before {
	fill: var(--color);
	stroke: var(--color);
}
</style>
